"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var OFFERING_TYPES = {
  EXPSTD: 'Expense - Standard',
  EXPPRO: 'Expense - Professional',
  INVSTD: 'Invoice - Standard',
  INVPRO: 'Invoice - Professional',
  TRVSTD: 'Travel - Standard',
  TRVPRO: 'Travel - Professional',
  TRQPRO: 'Travel Request - Professional',
  TRIPLINK: 'TripLink'
};
var _default = OFFERING_TYPES;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/config/offeringTypes.js
// module id = 273
// module chunks = 0